const c = {
  name: "Gambling",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11.5,9.1L11.5,9.1L11.5,9.1L11.5,9.1L11.5,9.1c-0.1,0.1-0.2,0.1-0.2,0.1c-0.1,0.1-0.4,0.2-0.6,0.4
			c-0.5,0.3-1.2,0.8-1.8,1.5c-1.3,1.2-2.8,3-2.8,5.2c0,1.9,1.6,3.5,3.5,3.5c0.5,0,1-0.1,1.5-0.3v3.3H8v2h8v-2h-3v-3.3
			c0.5,0.2,1,0.3,1.5,0.3c1.9,0,3.5-1.6,3.5-3.5c0-2.2-1.5-4-2.8-5.2c-0.7-0.6-1.3-1.1-1.8-1.5c-0.2-0.2-0.5-0.3-0.6-0.4
			c-0.1,0-0.1-0.1-0.2-0.1l0,0l0,0l0,0l0,0L12,8.8L11.5,9.1z M12,10l0.5-0.9C12.5,9.1,12.5,9.1,12,10z M12,10
			c-0.5-0.9-0.5-0.9-0.5-0.9L12,10z M13,16.4h-2c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5c0-1.3,1-2.6,2.2-3.8
			c0.6-0.5,1.2-1,1.6-1.3c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.2,0.1c0.4,0.3,1,0.7,1.6,1.3c1.2,1.1,2.2,2.5,2.2,3.8
			c0,0.8-0.7,1.5-1.5,1.5C13.7,17.9,13,17.2,13,16.4z"/>
		<path class="st0" d="M5,6.3c0.7,0,1.2-0.6,1.2-1.2S5.7,3.8,5,3.8C4.3,3.8,3.8,4.3,3.8,5S4.3,6.3,5,6.3z"/>
		<path class="st0" d="M20.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C19.7,27.8,20.3,28.3,20.3,29z"
			/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h18c1.5,0,2.7,1.1,3,2.5l14.2,5.9c1.5,0.6,2.3,2.4,1.6,3.9L29.1,38.1l0,0
			c-0.6,1.5-2.4,2.3-3.9,1.6l0,0L11.2,34H3c-1.7,0-3-1.3-3-3V3z M3,2C2.4,2,2,2.4,2,3v28c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V3
			c0-0.6-0.4-1-1-1H3z M24,31c0,1.7-1.3,3-3,3h-4.6l9.5,3.9l0,0c0.5,0.2,1.1,0,1.3-0.5l0,0l10.7-25.9c0.2-0.5,0-1.1-0.6-1.3L24,4.7
			V31z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Gambling
};
